import { render } from "./ArtistsPage.vue?vue&type=template&id=3b3e645a&scoped=true"
import script from "./ArtistsPage.vue?vue&type=script&lang=js"
export * from "./ArtistsPage.vue?vue&type=script&lang=js"

import "./ArtistsPage.vue?vue&type=style&index=0&id=3b3e645a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3e645a"]])

export default __exports__